<template>
    <div class="row">
      <div class="col-12" v-if="importNavigation.length > 0">
        <div class="element-wrapper">
          <h5 class="element-header">Import <span class="font-weight-bold text-danger" v-if="title1"> {{ t(title1, title1) }}</span> Links <span v-if="userLevelName"> <span class="font-weight-bold text-danger">from {{ userLevelName }}</span></span></h5>
          <div class="element-box">
            <div class="row">
              <draggable class="col-3 my-2 list-group bg-warning p-2 border border-white" :list="v" :group="{ name: 'navigation', pull: 'clone', put: false }" v-for="(v,i) in importNavigation" :key="i" v-bind="dragOptions">
                <div
                  class="btn btn-primary list-group-item my-1 ml-0"
                  v-for="element in v"
                  :key="element.name"
                >
                  {{ t(element.item_key, element.item_key) }}
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="element-wrapper">
          <h5 class="element-header" v-if="title1">{{ t(title1, title1) }}</h5>
          <div class="element-box" v-if="navigation1.length > 0">
            <div class="element-info">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <span class="os-icon os-icon-grid-squares"></span>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t(title1, title1) }}</h5>
                      <div class="element-inner-desc">Subnavigation for: {{ t(title1, title1) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-badge variant="primary" class="mr-2">Active</b-badge>
            <b-badge variant="danger">Inactive</b-badge>
            <div class="row">
              <draggable class="col-3 my-2 list-group bg-warning p-2 border border-white" :list="v" group="navigation" v-for="(v,column) in navigation1" :key="column" v-bind="dragOptions" @add="onAdded($event, column, navigation1)">
                <div
                  class="btn btn-primary whitespace list-group-item my-1 ml-0"
                  v-bind:class="{ 'btn-danger' : !element.active }"
                  v-for="(element, index) in v"
                  :key="element.name"
                  @click.self="changeLinkState($event, column, index, navigation1)"
                >
                  {{ t(element.item_key, element.item_key) }}
                  <span class="os-icon os-icon-x" style="color: white" @click="deleteLink(element.id, element.item_key)"></span>
                </div>
              </draggable>
              <div class="col-12 text-right px-0">
                <button class="btn btn-primary" @click="openNewLinkModal(parentId1)">Create Link</button>
                <button class="btn btn-secondary" @click="toggleImportBox()">Import Link</button>
                <button v-if="!isBusy" class="btn btn-primary" type="submit" @click="saveNavigation()">Save Navigation</button>
                <b-button v-if="isBusy" class="btn btn-primary" variant="primary" disabled>
                  <b-spinner small type="grow"></b-spinner>
                  Save Navigation
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="element-wrapper">
          <h5 class="element-header" v-if="title2">{{ t(title2, title2) }}</h5>
          <div class="element-box" v-if="navigation2.length > 0">
            <div class="element-info">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <span class="os-icon os-icon-grid-squares"></span>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t(title2, title2) }}</h5>
                      <div class="element-inner-desc">Subnavigation for: {{ t(title2, title2) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-badge variant="primary" class="mr-2">Active</b-badge>
            <b-badge variant="danger">Inactive</b-badge>
            <div class="row">
              <draggable class="col-3 my-2 list-group bg-warning p-2 border border-white" :list="v" group="navigation" v-for="(v,column) in navigation2" :key="column" v-bind="dragOptions" @add="onAdded($event, column, navigation2)">
                <div
                  class="btn btn-primary whitespace list-group-item my-1 ml-0"
                  v-bind:class="{ 'btn-danger' : !element.active }"
                  v-for="(element, index) in v"
                  :key="element.name"
                  @click.self="changeLinkState($event, column, index, navigation2)"
                >
                  {{ t(element.item_key, element.item_key) }}
                  <span class="os-icon os-icon-x" style="color: white" @click="deleteLink(element.id, element.item_key)"></span>
                </div>
              </draggable>
              <div class="col-12 text-right px-0">
                <button class="btn btn-primary" @click="openNewLinkModal(parentId2)">Create Link</button>
                <button class="btn btn-secondary" @click="toggleImportBox()">Import Link</button>
                <button v-if="!isBusy" class="btn btn-primary" type="submit" @click="saveNavigation()">Save Navigation</button>
                <b-button v-if="isBusy" class="btn btn-primary" variant="primary" disabled>
                  <b-spinner small type="grow"></b-spinner>
                  Save Navigation
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewLinkNavigationModal ref="newLinkModal" :parentId="parentId"></NewLinkNavigationModal>
      <div v-if="overlayActive" class="modal-backdrop show"></div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import NewLinkNavigationModal from '@/components/MenuBuilder/NewLinkNavigationModal.vue'

export default {
  name: "MenuNested",
  data() {
    return {
      overlayActive: false,
      parentId: 0
    }
  },
  components: {
    NewLinkNavigationModal,
    draggable
  },
  methods: {
    objectToArray(object) {
      var arr  = [],
      keys = Object.keys(object);

      for(var i=0,n=keys.length;i<n;i++){
        var key  = keys[i];
        arr[key] = object[key];
      }

      arr.shift()
      return arr
    },
    onAdded(evt, columnIndex, navigationArray) {
      let item_name = navigationArray[columnIndex][evt.newIndex].item_name
      let count = 0

      navigationArray.forEach(function (el) {
        el.filter(function (item) {
          if(item.item_name == item_name) {
            count = count + 1
          }
        });
      })

      if(count > 1) {
        navigationArray[columnIndex].splice([evt.newIndex], 1)
      }
    },

    toggleImportBox() {
      this.$parent.toggleImport()
    },

    saveNavigation() {
      this.$parent.updateNavigation()
    },

    changeLinkState(event, column, index, navigation) {
      navigation[column][index].active = (navigation[column][index].active == 0) ? 1 : 0
      if(navigation[column][index].active == 0) {
        event.target.classList.add('btn-danger')
      } else {
        event.target.classList.remove('btn-danger')
      }
    },
    disableOverlay() {
      this.overlayActive = false
    },
    openNewLinkModal(parent) {
      this.overlayActive = true
      this.parentId = parent

      let parentNavs = this.$props.activeParents
      //parentNavs.concat(this.$props.activeParents)
      parentNavs.concat(...this.$props.inactiveParents)
      this.$refs.newLinkModal.parentNavs = parentNavs
      this.$refs.newLinkModal.clearData()
      this.$root.$emit('bv::show::modal', 'newLinkModal')
    },
    deleteLink(linkId, linkName) {
      //console.log(linkId)
      this.$parent.deleteLink(linkId, linkName)
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "navigation",
        disabled: false,
        ghostClass: "ghost"
      };
    },

    isBusy() {
      return this.$parent.isBusy
    }
  },
  props: {
    links: {
      default: null,
      required: false
    },
    navigation1: {
      default: null,
      required: false
    },
    navigation2: {
      default: null,
      required: false
    },
    importNavigation: {
      default: null,
      required: false
    },
    title1: {
      default: null,
      required: false
    },
    title2: {
      default: null,
      required: false
    },
    parentId1: {
      default: null,
      required: false
    },
    parentId2: {
      default: null,
      required: false
    },
    activeParents: {
      default: [],
      required: false
    },
    inactiveParents: {
      default: [],
      required: false
    },
    userLevelName: {
      default: null,
      required: false
    }
  }
};
</script>

<style scoped>
.whitespace {
  white-space: inherit;
}
</style>